import { call, select } from "redux-saga/effects";
import { getUserInfo, storeCondition } from "shared/utils";

export function* setSignaturePenSizeConditionSaga(action: any): any {
  try {
    const userId = yield getUserInfo()?.user_id;
    yield call(storeCondition, "signaturePenSize", action.payload, userId);
  } catch (error) {
    console.log("function*setSignaturePenSizeConditionSaga ~ error", error);
  }
}
